import { TableColumn } from '../../../components/forms/form-entries/form-entry-list/entry-list/dynamic-table/dynamic-table.component';
import { EnergizedElecWorkPermit } from './energized-elec-work-permit.model';

export class EnergizedElecWorkPermitListItem {
  /** When the form was submitted ("Entry Date" column) */
  submissionDate: Date | null = null;

  /** The person who submitted the form ("User" column) */
  submittedByName: string | null = null;

  /** Basic Job Information */
  jobWorkOrderName: string | null = null;
  jobWorkOrderNumber: string | null = null;

  /** Part 1: To Be Completed By The Requester */
  circuitEquipmentDescription: string | null = null;
  upstreamOverCurrentDeviceLocation: string | null = null;
  workDescription: string | null = null;

  id: string = '';

  constructor(data?: Partial<EnergizedElecWorkPermitListItem>) {
    if (data) {
      Object.assign(this, data);
    }
  }

  static getTableColumns(): TableColumn[] {
    const columns: TableColumn[] = [];
    const instance = new EnergizedElecWorkPermitListItem();
    const fieldMappings = EnergizedElecWorkPermit.getFieldMappings();
    
    // Get all properties of the class
    Object.keys(instance).forEach(key => {
      // Skip the id property as it's handled separately
      if (key === 'id') return;

      // Determine the type based on the property value
      let type: 'text' | 'date' | 'action' | 'status' = 'text';
      const value = instance[key as keyof EnergizedElecWorkPermitListItem];
      
      if (value instanceof Date || (value === null && key.toLowerCase().includes('date'))) {
        type = 'date';
      }
      // All other values default to 'text' type

      // Add the column if it has a mapping
      if (fieldMappings[key]) {
        columns.push({
          key,
          label: fieldMappings[key],
          type,
          sortable: true
        });
      }
    });

    

    return columns;
  }

  static fromApiResponse(data: any): EnergizedElecWorkPermitListItem {
    return new EnergizedElecWorkPermitListItem({
      id: data.id,
      submissionDate: data.submissionDate ? new Date(data.submissionDate) : null,
      submittedByName: data.submittedByName,
      jobWorkOrderName: data.jobWorkOrderName,
      jobWorkOrderNumber: data.jobWorkOrderNumber,
      circuitEquipmentDescription: data.circuitEquipmentDescription,
      upstreamOverCurrentDeviceLocation: data.upstreamOverCurrentDeviceLocation,
      workDescription: data.workDescription
    });
  }
} 